import { render, staticRenderFns } from "./WisdomStatsMenu.vue?vue&type=template&id=2c76a10a&"
import script from "./WisdomStatsMenu.vue?vue&type=script&lang=js&"
export * from "./WisdomStatsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports